interface IProps {
    width?: number;
    height?: number;
}

export const ForwardIcon = (props: IProps) => {
    const {width, height} = props;
    return (<svg xmlns="http://www.w3.org/2000/svg" width={width || 24} height={height || 24} viewBox="0 0 24 24"
                 fill="none">
        <path
            d="M12.0433 7.87879C2.88753 7.87879 1.59378 15.9596 2.09137 20C4.08176 14.1818 9.5553 14.1818 12.0433 14.1818V18.0606L21 11.2727L12.0433 4V7.87879Z"
            fill="#FCFCFC"/>
    </svg>)
}